"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var window_or_global_1 = __importDefault(require("window-or-global"));
exports.footerReady = function (callbackFn) {
    var prevReady;
    if (window_or_global_1.default._egFooterReadyCallback && typeof window_or_global_1.default._egFooterReadyCallback === 'function') {
        prevReady = window_or_global_1.default._egFooterReadyCallback;
    }
    window_or_global_1.default._egFooterReadyCallback = function () {
        if (callbackFn && typeof callbackFn === 'function') {
            callbackFn();
        }
        if (prevReady)
            prevReady.apply(this);
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9vdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Zvb3Rlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUFBLHNFQUFvQztBQU12QixRQUFBLFdBQVcsR0FBRyxVQUFBLFVBQVU7SUFDakMsSUFBSSxTQUFTLENBQUM7SUFDZCxJQUFJLDBCQUFJLENBQUMsc0JBQXNCLElBQUksT0FBTywwQkFBSSxDQUFDLHNCQUFzQixLQUFLLFVBQVUsRUFBRTtRQUNsRixTQUFTLEdBQUcsMEJBQUksQ0FBQyxzQkFBc0IsQ0FBQztLQUMzQztJQUVELDBCQUFJLENBQUMsc0JBQXNCLEdBQUc7UUFDMUIsSUFBSSxVQUFVLElBQUksT0FBTyxVQUFVLEtBQUssVUFBVSxFQUFFO1lBQ2hELFVBQVUsRUFBRSxDQUFDO1NBQ2hCO1FBQ0QsSUFBSSxTQUFTO1lBQUUsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN6QyxDQUFDLENBQUM7QUFDTixDQUFDLENBQUMifQ==